import { Doctor, Service, Patient, Appointment, Testimonial, ClinicInfo, DashboardStats } from '../types';

export const mockDoctors: Doctor[] = [
  {
    id: '1',
    name: 'Dr. Sarah Johnson',
    specialty: 'Cardiology',
    qualifications: ['MD', 'FACC', 'Board Certified Cardiologist'],
    photo: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop&crop=face',
    bio: 'Dr. Johnson has over 15 years of experience in cardiovascular medicine with a focus on preventive cardiology and interventional procedures.',
    rating: 4.9,
    reviewCount: 124,
    isAvailable: true,
    schedule: [
      { dayOfWeek: 1, startTime: '09:00', endTime: '17:00', isWorking: true },
      { dayOfWeek: 2, startTime: '09:00', endTime: '17:00', isWorking: true },
      { dayOfWeek: 3, startTime: '09:00', endTime: '17:00', isWorking: true },
      { dayOfWeek: 4, startTime: '09:00', endTime: '17:00', isWorking: true },
      { dayOfWeek: 5, startTime: '09:00', endTime: '15:00', isWorking: true },
      { dayOfWeek: 6, startTime: '00:00', endTime: '00:00', isWorking: false },
      { dayOfWeek: 0, startTime: '00:00', endTime: '00:00', isWorking: false },
    ],
  },
  {
    id: '2',
    name: 'Dr. Michael Chen',
    specialty: 'Orthopedics',
    qualifications: ['MD', 'MS Orthopedics', 'Fellowship in Sports Medicine'],
    photo: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=400&h=400&fit=crop&crop=face',
    bio: 'Specializing in sports medicine and joint replacement surgery with over 12 years of experience.',
    rating: 4.8,
    reviewCount: 98,
    isAvailable: true,
    schedule: [
      { dayOfWeek: 1, startTime: '08:00', endTime: '16:00', isWorking: true },
      { dayOfWeek: 2, startTime: '08:00', endTime: '16:00', isWorking: true },
      { dayOfWeek: 3, startTime: '08:00', endTime: '16:00', isWorking: true },
      { dayOfWeek: 4, startTime: '08:00', endTime: '16:00', isWorking: true },
      { dayOfWeek: 5, startTime: '08:00', endTime: '14:00', isWorking: true },
      { dayOfWeek: 6, startTime: '09:00', endTime: '13:00', isWorking: true },
      { dayOfWeek: 0, startTime: '00:00', endTime: '00:00', isWorking: false },
    ],
  },
  {
    id: '3',
    name: 'Dr. Emily Rodriguez',
    specialty: 'Dermatology',
    qualifications: ['MD', 'Board Certified Dermatologist', 'Fellowship in Cosmetic Dermatology'],
    photo: 'https://images.unsplash.com/photo-1594824202781-d8155d7e5e8c?w=400&h=400&fit=crop&crop=face',
    bio: 'Expert in medical and cosmetic dermatology with a passion for helping patients achieve healthy, beautiful skin.',
    rating: 4.9,
    reviewCount: 156,
    isAvailable: true,
    schedule: [
      { dayOfWeek: 1, startTime: '10:00', endTime: '18:00', isWorking: true },
      { dayOfWeek: 2, startTime: '10:00', endTime: '18:00', isWorking: true },
      { dayOfWeek: 3, startTime: '10:00', endTime: '18:00', isWorking: true },
      { dayOfWeek: 4, startTime: '10:00', endTime: '18:00', isWorking: true },
      { dayOfWeek: 5, startTime: '10:00', endTime: '16:00', isWorking: true },
      { dayOfWeek: 6, startTime: '00:00', endTime: '00:00', isWorking: false },
      { dayOfWeek: 0, startTime: '00:00', endTime: '00:00', isWorking: false },
    ],
  },
  {
    id: '4',
    name: 'Dr. David Williams',
    specialty: 'Internal Medicine',
    qualifications: ['MD', 'Board Certified Internal Medicine', 'Geriatric Medicine Certification'],
    photo: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop&crop=face',
    bio: 'Primary care physician with expertise in chronic disease management and preventive medicine.',
    rating: 4.7,
    reviewCount: 89,
    isAvailable: true,
    schedule: [
      { dayOfWeek: 1, startTime: '08:30', endTime: '17:30', isWorking: true },
      { dayOfWeek: 2, startTime: '08:30', endTime: '17:30', isWorking: true },
      { dayOfWeek: 3, startTime: '08:30', endTime: '17:30', isWorking: true },
      { dayOfWeek: 4, startTime: '08:30', endTime: '17:30', isWorking: true },
      { dayOfWeek: 5, startTime: '08:30', endTime: '15:30', isWorking: true },
      { dayOfWeek: 6, startTime: '00:00', endTime: '00:00', isWorking: false },
      { dayOfWeek: 0, startTime: '00:00', endTime: '00:00', isWorking: false },
    ],
  },
];

export const mockServices: Service[] = [
  {
    id: '1',
    name: 'General Consultation',
    description: 'Comprehensive health evaluation and consultation with our experienced physicians.',
    price: 150,
    duration: 30,
    category: 'General Medicine',
    icon: 'stethoscope',
  },
  {
    id: '2',
    name: 'Cardiology Consultation',
    description: 'Specialized heart health evaluation and treatment planning.',
    price: 250,
    duration: 45,
    category: 'Cardiology',
    icon: 'heart',
  },
  {
    id: '3',
    name: 'Orthopedic Consultation',
    description: 'Bone, joint, and muscle health assessment and treatment.',
    price: 200,
    duration: 40,
    category: 'Orthopedics',
    icon: 'bone',
  },
  {
    id: '4',
    name: 'Dermatology Consultation',
    description: 'Skin health evaluation and cosmetic dermatology services.',
    price: 180,
    duration: 30,
    category: 'Dermatology',
    icon: 'shield',
  },
  {
    id: '5',
    name: 'Annual Physical Exam',
    description: 'Comprehensive yearly health check-up and preventive care.',
    price: 300,
    duration: 60,
    category: 'Preventive Care',
    icon: 'clipboard-check',
  },
  {
    id: '6',
    name: 'Blood Test Panel',
    description: 'Complete blood work analysis including CBC, metabolic panel, and lipid profile.',
    price: 120,
    duration: 15,
    category: 'Laboratory',
    icon: 'test-tube',
  },
  {
    id: '7',
    name: 'ECG/EKG',
    description: 'Electrocardiogram to assess heart rhythm and electrical activity.',
    price: 100,
    duration: 20,
    category: 'Cardiology',
    icon: 'activity',
  },
  {
    id: '8',
    name: 'X-Ray Imaging',
    description: 'Digital X-ray imaging for bone and chest examinations.',
    price: 150,
    duration: 15,
    category: 'Imaging',
    icon: 'scan',
  },
];

export const mockTestimonials: Testimonial[] = [
  {
    id: '1',
    patientName: 'John Smith',
    rating: 5,
    comment: 'Excellent care and very professional staff. Dr. Johnson explained everything clearly and made me feel comfortable throughout the entire process.',
    date: '2024-01-15',
    serviceId: '2',
    isVerified: true,
  },
  {
    id: '2',
    patientName: 'Maria Garcia',
    rating: 5,
    comment: 'The best medical experience I\'ve had. The facility is modern and clean, and the staff is incredibly caring.',
    date: '2024-01-10',
    serviceId: '1',
    isVerified: true,
  },
  {
    id: '3',
    patientName: 'Robert Thompson',
    rating: 4,
    comment: 'Great service and very thorough examination. The online booking system made scheduling so easy.',
    date: '2024-01-08',
    serviceId: '5',
    isVerified: true,
  },
  {
    id: '4',
    patientName: 'Lisa Chen',
    rating: 5,
    comment: 'Dr. Rodriguez is amazing! She took great care of my skin condition and the results are fantastic.',
    date: '2024-01-05',
    serviceId: '4',
    isVerified: true,
  },
];

export const mockClinicInfo: ClinicInfo = {
  name: 'ClinicIT Medical Center',
  tagline: 'Your Health, Our Priority',
  description: 'A modern medical facility providing comprehensive healthcare services with state-of-the-art technology and compassionate care.',
  address: {
    street: '123 Medical Plaza Drive',
    city: 'San Francisco',
    state: 'CA',
    zipCode: '94102',
    country: 'United States',
  },
  phone: '+1 (555) 123-4567',
  email: 'info@healthcareplus.com',
  website: 'www.healthcareplus.com',
  hours: {
    monday: { open: '08:00', close: '18:00', isClosed: false },
    tuesday: { open: '08:00', close: '18:00', isClosed: false },
    wednesday: { open: '08:00', close: '18:00', isClosed: false },
    thursday: { open: '08:00', close: '18:00', isClosed: false },
    friday: { open: '08:00', close: '17:00', isClosed: false },
    saturday: { open: '09:00', close: '14:00', isClosed: false },
    sunday: { open: '00:00', close: '00:00', isClosed: true },
  },
  socialMedia: {
    facebook: 'https://facebook.com/healthcareplus',
    twitter: 'https://twitter.com/healthcareplus',
    instagram: 'https://instagram.com/healthcareplus',
    linkedin: 'https://linkedin.com/company/healthcareplus',
  },
};

export const mockDashboardStats: DashboardStats = {
  totalPatients: 1248,
  todayAppointments: 24,
  monthlyRevenue: 185400,
  upcomingAppointments: 156,
  completedAppointments: 892,
  cancelledAppointments: 34,
};

// Generate mock appointments
export const generateMockAppointments = (): Appointment[] => {
  const appointments: Appointment[] = [];
  const statuses: Appointment['status'][] = ['scheduled', 'confirmed', 'completed', 'cancelled'];
  
  for (let i = 1; i <= 50; i++) {
    const date = new Date();
    date.setDate(date.getDate() + Math.floor(Math.random() * 30) - 15); // ±15 days from today
    
    appointments.push({
      id: `apt-${i}`,
      patientId: `patient-${Math.floor(Math.random() * 20) + 1}`,
      doctorId: mockDoctors[Math.floor(Math.random() * mockDoctors.length)].id,
      serviceId: mockServices[Math.floor(Math.random() * mockServices.length)].id,
      date: date.toISOString().split('T')[0],
      time: `${Math.floor(Math.random() * 8) + 9}:${Math.random() > 0.5 ? '00' : '30'}`,
      duration: 30,
      status: statuses[Math.floor(Math.random() * statuses.length)],
      notes: Math.random() > 0.5 ? 'Regular checkup' : undefined,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }
  
  return appointments;
};

export const generateMockPatients = (): Patient[] => {
  const patients: Patient[] = [];
  const firstNames = ['John', 'Jane', 'Michael', 'Emily', 'David', 'Sarah', 'Robert', 'Lisa', 'William', 'Maria'];
  const lastNames = ['Smith', 'Johnson', 'Brown', 'Davis', 'Wilson', 'Miller', 'Taylor', 'Anderson', 'Thomas', 'Jackson'];
  
  for (let i = 1; i <= 20; i++) {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    
    patients.push({
      id: `patient-${i}`,
      firstName,
      lastName,
      email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@email.com`,
      phone: `+1 (555) ${String(Math.floor(Math.random() * 900) + 100)}-${String(Math.floor(Math.random() * 9000) + 1000)}`,
      dateOfBirth: `19${Math.floor(Math.random() * 50) + 50}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
      gender: Math.random() > 0.5 ? 'male' : 'female',
      address: {
        street: `${Math.floor(Math.random() * 9999) + 1} Main St`,
        city: 'San Francisco',
        state: 'CA',
        zipCode: '94102',
        country: 'United States',
      },
      emergencyContact: {
        name: `Emergency Contact ${i}`,
        relationship: 'Spouse',
        phone: `+1 (555) ${String(Math.floor(Math.random() * 900) + 100)}-${String(Math.floor(Math.random() * 9000) + 1000)}`,
      },
      medicalHistory: [],
      appointments: [],
      createdAt: new Date().toISOString(),
    });
  }
  
  return patients;
};